import {  Flex, Form, Space, Table, DatePicker, Radio, Input } from 'antd'
import React, { useEffect, useState } from 'react'
import classes from './report.module.css';   
import ReportCheck from './ReportCheck';
import Icon from '../../cpn/Icon';
import dayjs from 'dayjs';
import ClientCheck from '../../system/client/ClientCheck';
import ClientSelect from '../../system/client/ClientSelect';
import StateTag from '../../cpn/StateTag';
import ReportOpSelect from './ReportOpSelect';
function ReportListAll(props) {
    const [form] = Form.useForm();    
    const [list, setList] = useState([]);
    const [query, setQuery] = useState({ "dsbzd_kh_id": '', "dsbzd_id": ''});
    useEffect(() => {        
        let arr = (props.list || []).slice(); // 创建数组副本，避免修改只读数组
        if(query.dsbzd_kh_id){
            arr = arr.filter((item) => item.dsbzd_kh_id === query.dsbzd_kh_id);
        }
        if(query.dsbzd_uid){
            arr = arr.filter((item) => item.dsbzd_uid === query.dsbzd_uid);
        }
        if(query.dsbzd_date_end){
            arr = arr.filter((item) => dayjs(item.dsbzd_date_end).format('YYYY-MM-DD') === query.dsbzd_date_end);
        }
        if(query.dsbzd_state){
            arr = arr.filter((item) => item.dsbzd_state === query.dsbzd_state);
        }
        if(query.dsbzd_id){
            arr = arr.filter((item) => item.dsbzd_id === query.dsbzd_id);
        }
        arr.sort((a,b) => dayjs(b.dsbzd_ctime).diff(dayjs(a.dsbzd_ctime)));
        setList(arr);
    }, [props.list, props.yh_id, query.dsbzd_kh_id, query.dsbzd_uid, query.dsbzd_date_end, query.dsbzd_state, query.dsbzd_id]);
    

    const columnsTable = [   
        {
            key: 'dsbzd_name',
            dataIndex: 'dsbzd_name',
            title: "团队名称",
            render: (_, record) => <ReportCheck
                                        dsbzd_id={record.dsbzd_id} 
                                        commonList={props.commonList}
                                        qy_id={props.qy_id}
                                        qy_name={props.qy_name}
                                        yh_id={props.yh_id}
                                        yh_name={props.yh_name}
                                        dsbzd_name={record.dsbzd_name}
                                        spjdList={props.spjdList}
                                        dsbzd_kh_name={record.dsbzd_kh_name}
                                        dsbzd_uid={record.dsbzd_uid}
                                        dsbzd_state={record.dsbzd_state}
                                        dsbzd_ctime={record.dsbzd_ctime}
                                        dsbzd_state_time={record.dsbzd_state_time}
                                        listType='all'
                                    />
        },             
       
        {
            key: 'dsbzd_date',
            dataIndex: 'dsbzd_date',
            title: "开始日期",
            width: "6%",            
        },
        {
            key: 'dsbzd_date_end',
            dataIndex: 'dsbzd_date_end',
            title: "结束日期",
            width: "6%",
        },
        {
            key: 'dsbzd_date_end',
            dataIndex: 'dsbzd_date_end',
            title: "天数",
            width: "3%",
            render: (_, record) => <>{dayjs(record.dsbzd_date_end).diff(dayjs(record.dsbzd_date), 'day') + 1}</>,
        },
      
        {
            key: 'dsbzd_kh_name',
            dataIndex: 'dsbzd_kh_name',
            title: "客户",
            width: "8%",
            render: (text, record) => <ClientCheck kh_id={record.dsbzd_kh_id} kh_name={record.dsbzd_kh_name} qy_id={props.qy_id} qy_name={props.qy_name} yh_id={props.yh_id} yh_name={props.yh_name} />
        },
        {
            key: 'dsbzd_khlxr_name',
            dataIndex: 'dsbzd_khlxr_name',
            title: "对接人",
            width: "8%",
        },
        {
            key: 'dsbzd_bm_name',
            dataIndex: 'dsbzd_bm_name',
            title: "部门",
            width: "6%",
        },        
        {
            key: 'dsbzd_jd_name',   
            dataIndex: 'dsbzd_jd_name',
            title: "计调",
            width: "6%",
        },             
          
        {
            key: 'dsbzd_state',
            dataIndex: 'dsbzd_state',
            title: "状态",
            width: "10%",
            render: (text, record) => <StateTag state={record.dsbzd_state} />
        },
        {
            key: 'dsbzd_id',
            dataIndex: 'dsbzd_id',
            title: "编号",
            width: "4%",            
        },
    ];

    return (
        <>   
            <Flex style={{ marginBottom: "10px" }} align='center' justify='space-between' gap={10}>
                <Form
                    layout='inline'
                    name='form_all'
                    form={form}
                    initialValues={{
                        dsbzd_kh_id: undefined,
                    }}
                    onFinish={(values) => {                        
                        console.log(query);
                        
                        setQuery(prev => ({ ...prev, ...values }));
                    }}
                >
                    <ClientSelect                       
                        formStyle={{ marginBottom: "0" }}
                        onClear={() => { setQuery(prev => ({ ...prev, dsbzd_kh_id: '' })) }}
                        placeholder='报账单客户'
                        qy_id={props.qy_id}
                        style={{ width: "150px" }}
                        name='dsbzd_kh_id'
                        onChange={(e) => {}}
                        yh_id={props.yh_id}
                        list={props.commonList?.kf_data || props.commonList?.kh_data || []}
                        wrapperCol={{ span: 18 }}
                    />                    
                    <ReportOpSelect
                        formStyle={{ marginBottom: "0" }}
                        onClear={() => { setQuery(prev => ({ ...prev, dsbzd_uid: '' })) }}
                        placeholder='报账单操作员'
                        qy_id={props.qy_id}
                        style={{ width: "150px" }}
                        name='dsbzd_uid'
                        onChange={(e) => {}}
                    />
                    <Form.Item name='dsbzd_date_end'>
                        <DatePicker 
                            onChange={(value) => {
                                setQuery(prev => ({ ...prev, dsbzd_date_end: dayjs(value).format('YYYY-MM-DD') }));
                            }}
                            value={query.dsbzd_date_end ? dayjs(query.dsbzd_date_end) : null}
                            allowClear={true}
                            placeholder='结束日期'
                            name='dsbzd_date_end'
                        />
                    </Form.Item>
                    <Form.Item name='dsbzd_id' >
                        <Input placeholder='报账单编号' onChange={(e) => {setQuery(prev => ({ ...prev, dsbzd_id: e.target.value || '' }))}} style={{ width: "100px" }} />
                    </Form.Item>
                    <Form.Item 
                        name='dsbzd_state' 
                        label={props.label} 
                        required={props.required} 
                        style={props.style} 
                        wrapperCol={props.wrapperCol}
                        noStyle
                    >
                        <Radio.Group 
                            onChange={(e) => {
                                setQuery(prev => ({ 
                                    ...prev, 
                                    dsbzd_state: e.target.value,                                     
                                }));
                            }}
                            buttonStyle='solid'
                            optionType="button" 
                        >
                            <Radio value='' >全部</Radio>
                            <Radio value='2' >待审批</Radio>
                            <Radio value='3' >审批中</Radio>                
                            <Radio value='4' >已驳回</Radio>
                            <Radio value='5' >已结束（未读）</Radio>
                            <Radio value='6' >已结束（已读）</Radio>
                        </Radio.Group>        
                    </Form.Item>
                    <Form.Item wrapperCol={{ offset: 2 }}>
                        <Space align='center' size='middle'>
                            <Icon type='search' onClick={() => {form.submit()}}/>
                            <Icon 
                                type='reset'
                                title='重置查询条件'
                                onClick={() => {
                                    form.resetFields()
                                    setQuery({"dsbzd_kh_id": '',})
                                    form.setFieldsValue({dsbzd_kh_id: undefined});
                                }}
                            />
                            
                        </Space>
                    </Form.Item>
                </Form>
            </Flex>
            <Table               
                dataSource={list}
                columns={columnsTable}
                className={classes.customTable}
                size='small'
                bordered
                rowKey="dsbzd_id"
                pagination={{
                    pageSize: 50,
                    pageSizeOptions: [10, 20, 50, 100],
                    showSizeChanger: true,
                    showQuickJumper: true,
                    showTotal: (total, range) => `共 ${total} 条`,
                    onChange: (page, pageSize) => {
                        console.log(page, pageSize);
                    }
                }}
            />
           
        </>
    )
}

export default ReportListAll